import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    loadAuftragMultimediaListStatus: 'idle',
    loadAuftragMultimediaListError: undefined as any,
    loadAuftragMultimediaListLastArgs: undefined as any,
    loadAuftragMultimediaStatus: 'idle',
    loadAuftragMultimediaError: undefined as any,
    saveAuftragMultimediaStatus: 'idle',
    saveAuftragMultimediaError: undefined as any,
    deleteAuftragMultimediaStatus: 'idle',
    deleteAuftragMultimediaError: undefined as any,

    auftragMultimediaList: [] as any[],
    formItem: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const loadAuftragMultimediaList = createAsyncThunk('auftragMultimediaSlice/loadAuftragMultimediaList', async ({ parentModel, forceReload }: any, { rejectWithValue, getState }: any) => {
    const lastArgs = getState().auftragMultimediaSlice.loadAuftragMultimediaListLastArgs
    if (_.isEqual(lastArgs, { parentModel }) && !forceReload) { return }

    let promises = []
    promises.push(client.get(
        `/api/ixweb/ncremmultimedia/?action=gte&MIN_MODULTYPE=1&MAX_MODULTYPE=1&MIN_MODULOBJID=${parentModel.HDR_ID}&MAX_MODULOBJID=${parentModel.HDR_ID}`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
        args: { parentModel }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadAuftragMultimediaListStatus } = getState().auftragMultimediaSlice
        return loadAuftragMultimediaListStatus !== 'pending'
    }
})

export const loadAuftragMultimedia = createAsyncThunk('auftragMultimediaSlice/loadAuftragMultimedia', async ({ id }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/ncremmultimedia/?action=eql&HDR_ID=${id}`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadAuftragMultimediaStatus } = getState().auftragMultimediaSlice
        return loadAuftragMultimediaStatus !== 'pending'
    }
})

export const saveAuftragMultimedia = createAsyncThunk('auftragMultimediaSlice/saveAuftragMultimedia', async ({ auftragMultimedia }: any, { rejectWithValue }: any) => {
    let promises = []
    if (auftragMultimedia?.HDR_ID) {
        promises.push(client.put(
            `/api/ixweb/ncremmultimedia/${ auftragMultimedia?.HDR_ID }/`,
            prepareData(auftragMultimedia),
        ))
    } else {
        promises.push(client.post(
            `/api/ixweb/ncremmultimedia/`,
            prepareData(auftragMultimedia),
        ))
    }

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { saveAuftragMultimediaStatus } = getState().auftragMultimediaSlice
        return saveAuftragMultimediaStatus !== 'pending'
    }
})

export const deleteAuftragMultimedia = createAsyncThunk('auftragMultimediaSlice/deleteAuftragMultimedia', async ({ id }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.delete(
        `/api/ixweb/ncremmultimedia/${id}/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: id,
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { deleteAuftragMultimediaStatus } = getState().auftragMultimediaSlice
        return deleteAuftragMultimediaStatus !== 'pending'
    }
})

const AuftragMultimediaSlice = createSlice({
    name: 'auftragMultimediaSlice',
    initialState,
    reducers: {
        resetloadAuftragMultimediaListError: (state) => {
            state.loadAuftragMultimediaListError = undefined
        },
        resetloadAuftragMultimedia: (state) => {
            state.formItem = undefined
            state.loadAuftragMultimediaError = undefined
        },
        resetloadAuftragMultimediaError: (state) => {
            state.loadAuftragMultimediaError = undefined
        },
        resetsaveAuftragMultimedia: (state) => {
            state.formItem = undefined
            state.saveAuftragMultimediaError = undefined
        },
        resetsaveAuftragMultimediaError: (state) => {
            state.saveAuftragMultimediaError = undefined
        },
        resetdeleteAuftragMultimediaError: (state) => {
            state.deleteAuftragMultimediaError = undefined
        },
        removeFromAuftragMultimediaListById: (state, action) => {
            state.auftragMultimediaList = state.auftragMultimediaList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromAuftragMultimediaListByIds: (state, action) => {
            state.auftragMultimediaList = state.auftragMultimediaList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.auftragMultimediaList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.loadAuftragMultimediaListStatus = 'preloaded'
            state.loadAuftragMultimediaListLastArgs = ''
        },
        clearPreloadedData: (state) => {
            state.auftragMultimediaList = []
            state.loadAuftragMultimediaListStatus = 'idle'
            state.loadAuftragMultimediaListLastArgs = undefined
        },
    },
    extraReducers: builder => {
        builder.addCase(loadAuftragMultimediaList.pending, (state) => {
            state.loadAuftragMultimediaListStatus = 'pending'
            state.loadAuftragMultimediaListError = undefined
        })
        builder.addCase(loadAuftragMultimediaList.fulfilled, (state, action) => {
            state.loadAuftragMultimediaListStatus = 'idle'

            if (!action.payload) { return }

            state.loadAuftragMultimediaListLastArgs = action.payload.args

            {
                state.auftragMultimediaList = action.payload.data

            }
        })
        builder.addCase(loadAuftragMultimediaList.rejected, (state, action) => {
            state.loadAuftragMultimediaListStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadAuftragMultimediaListError = action.error.message
            } else {
                state.loadAuftragMultimediaListError = action.payload
            }
        })

        builder.addCase(loadAuftragMultimedia.pending, (state) => {
            state.loadAuftragMultimediaStatus = 'pending'
            state.loadAuftragMultimediaError = undefined
        })
        builder.addCase(loadAuftragMultimedia.fulfilled, (state, action) => {
            state.loadAuftragMultimediaStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.auftragMultimediaList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.auftragMultimediaList.push(newItem) }
                else { state.auftragMultimediaList[i] = { ...state.auftragMultimediaList[i], ...newItem } }
            }
        })
        builder.addCase(loadAuftragMultimedia.rejected, (state, action) => {
            state.loadAuftragMultimediaStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadAuftragMultimediaError = action.error.message
            } else {
                state.loadAuftragMultimediaError = action.payload
            }
        })

        builder.addCase(saveAuftragMultimedia.pending, (state) => {
            state.saveAuftragMultimediaStatus = 'pending'
            state.saveAuftragMultimediaError = undefined
        })
        builder.addCase(saveAuftragMultimedia.fulfilled, (state, action) => {
            state.saveAuftragMultimediaStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.auftragMultimediaList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.auftragMultimediaList.push(newItem) }
                else { state.auftragMultimediaList[i] = { ...state.auftragMultimediaList[i], ...newItem } }
            }
        })
        builder.addCase(saveAuftragMultimedia.rejected, (state, action) => {
            state.saveAuftragMultimediaStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.saveAuftragMultimediaError = action.error.message
            } else {
                state.saveAuftragMultimediaError = action.payload
            }
        })

        builder.addCase(deleteAuftragMultimedia.pending, (state) => {
            state.deleteAuftragMultimediaStatus = 'pending'
            state.deleteAuftragMultimediaError = undefined
        })
        builder.addCase(deleteAuftragMultimedia.fulfilled, (state, action) => {
            state.deleteAuftragMultimediaStatus = 'idle'

            {
                if (Array.isArray(action.payload.data)) {
                    state.auftragMultimediaList = state.auftragMultimediaList.filter((x: any) => !action.payload.data.includes(x.HDR_ID))
                } else {
                    state.auftragMultimediaList = state.auftragMultimediaList.filter((x: any) => x.HDR_ID !== action.payload.data)
                }
            }
        })
        builder.addCase(deleteAuftragMultimedia.rejected, (state, action) => {
            state.deleteAuftragMultimediaStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.deleteAuftragMultimediaError = action.error.message
            } else {
                state.deleteAuftragMultimediaError = action.payload
            }
        })

    }
})

export const {
    resetloadAuftragMultimediaListError,
    resetloadAuftragMultimedia,
    resetloadAuftragMultimediaError,
    resetsaveAuftragMultimedia,
    resetsaveAuftragMultimediaError,
    resetdeleteAuftragMultimediaError,
    removeFromAuftragMultimediaListById,
    removeFromAuftragMultimediaListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = AuftragMultimediaSlice.actions
export default AuftragMultimediaSlice.reducer
